export const CHART_VIEW_SETTINGS_BRUSH = 'brush';
export const CHART_VIEW_SETTINGS_LEGEND = 'legend';
export const CHART_VIEW_SETTINGS_TYPE = 'type';
export const CHART_VIEW_SETTINGS_PIE_LABEL_TYPE = 'pieLabelType';
export const CHART_VIEW_SETTINGS_STACKED = 'stacked';
export const CHART_VIEW_SETTINGS_PERCENTAGE = 'percentage';
export const CHART_VIEW_SETTINGS_FULL_NAME = 'fullName';
export const CHART_VIEW_SETTINGS_LABEL = 'label';
export const CHART_METRIC_MIXED_TYPES = 'metricMixedTypes';
export const CHART_BREAKDOWN_METRIC_TYPES = 'breakdownMixedTypes';
